import React from 'react';
import Layout from '../../../components/Layout';
import Reveal, { SplitWords } from '../../../components/Reveal';

/**
 * @author Nelson
 */
const AboutUs = () => (
    <Layout title="About">
        <header className="page__head">
            <h1 className="page__eyebrow reveal" style={{ '--reveal-delay': '80ms' }}>
                About YUAN Lab Enterprise
            </h1>
            <h2 className="page__title page__title--display">
                <SplitWords text="Who We Are" start={200} />
            </h2>
        </header>

        <div className="prose">
            <Reveal as="p" delay={480}>
                YUAN Lab Enterprise is a creative software team focused on building mobile apps that are fun, functional, and refreshingly simple.
            </Reveal>
            <Reveal as="p" delay={550}>
                Founded with the belief that digital tools should enhance real-world moments, we develop everything from interactive party games to clever everyday utilities.
            </Reveal>
            <Reveal as="p" delay={620}>
                While we started with casual game ideas, our vision has grown to include a diverse range of mobile experiences — some for entertainment, some for solving small real-world problems.
            </Reveal>
            <Reveal as="p" delay={690}>
                We're a small, passionate group of developers, designers, and thinkers who believe great apps don't have to be complicated — they just have to feel right.
            </Reveal>
        </div>
    </Layout>
);

export default AboutUs;
